















import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  name: 'BrowseAndGoPageHeader'
})
export default class extends Vue {
  @Prop({ required: true }) private title!: string
  @Prop({ default: '' }) private subtitle!: string
}
